import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#21456A",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#6C757D",
    },
    error: {
      main: "#A95149",
    },
    background: {
      default: "#F4F6F8",
    },
    text: {
      primary: "#000000",
    },
    common: {
      white: {
        main: "#FFFFFF",
      },
      black: {
        main: "#000000",
      },
    },
  },
  spacing: 10,
  // components: {
  //   MuiButton: {
  //     defaultProps: {
  //       variant: 'contained',
  //     },
  //   },
  // },
});

export default theme;
